import * as React from "react"
import { AuthProvider } from "./src/context/AuthContext"
import { ChatsProvider } from "./src/context/ChatsContext"
import { RedirectProvider } from "./src/context/RedirectContext"
import { NotifierContextProvider } from "react-headless-notifier"
import { Script } from "gatsby"
import "./src/css/index.css"

export const wrapRootElement = ({ element }) => {
  return (
    <AuthProvider>
      <ChatsProvider>
        <RedirectProvider>
          <NotifierContextProvider
            config={{
              max: null,
              duration: 8000,
              position: "topRight",
            }}
          >
            <Script>
              {`
                (function(h,o,t,j,a,r){
                    h.hj=h.hj||function(){(h.hj.q=h.hj.q||[]).push(arguments)};
                    h._hjSettings={hjid:3184543,hjsv:6};
                    a=o.getElementsByTagName('head')[0];
                    r=o.createElement('script');r.async=1;
                    r.src=t+h._hjSettings.hjid+j+h._hjSettings.hjsv;
                    a.appendChild(r);
                })(window,document,'https://static.hotjar.com/c/hotjar-','.js?sv=');
              `}
            </Script>
            {element}
          </NotifierContextProvider>
        </RedirectProvider>
      </ChatsProvider>
    </AuthProvider>
  )
}
